import Image from "next/image";
import React, { useEffect, useState } from "react";
import Remote from "../../LoaderRemote";
import { useTranslation } from "../../../context/TranslationContext";

const Pagefour = ({
  formdata,
  setformdata,
  validSteps,
  setvalidSteps,
  data,
}) => {
  const [checked, setChecked] = useState(formdata.Categories);
  const handleChange = (e) => {
    if (e.target.checked) {
      setChecked([...checked, e.target.value]);
    } else {
      const old = [...checked];
      const index = old.findIndex((a) => a == e.target.value);
      old.splice(index, 1);
      setChecked(old);
    }
  };
  useEffect(() => {
    setformdata({ ...formdata, Categories: checked });
    setvalidSteps({ ...validSteps, 4: checked.length > 0 });
  }, [checked]);
  const { getOfferStep4Title } = useTranslation();
  return (
    <div className="flex flex-col mb-7">
      <div className="flex justify-center mb-6">
        <span className="md:text-25 text-15 text-black font-medium">
          {getOfferStep4Title}
        </span>
      </div>
      <div className="grid sm:grid-cols-2 grid-cols-1 gap-6">
        {data.Categories.filter(
          (e) => e[formdata.categoryType == "1" ? "ozelGun" : "aile"] == "1",
        ).map((e) => (
          <label
            key={e.id}
            className="w-full font-normal text-[14px]  flex items-center justify-between cursor-pointer"
          >
            <div className="flex items-center">
              <div className="w-[60px] h-[60px] rounded-full mr-2 relative p-1">
                {e.icon && (
                  <Image
                    src={e.icon}
                    width={60}
                    height={60}
                    className="object-contain"
                    alt={e.baslik}
                    loader={Remote}
                  />
                )}
              </div>
              {e.baslik}
            </div>
            <input
              type="checkbox"
              value={e.id}
              name="Categories"
              className="w-8 h-8"
              onChange={handleChange}
              checked={checked.includes(e.id)}
            />
          </label>
        ))}
      </div>
    </div>
  );
};

export default Pagefour;
